function createPromise(signal) {
  let resolver = () => {
  };
  let rejector = () => {
  };
  const promise = new Promise((resolve, reject) => {
    if (signal?.aborted) {
      reject(signal.reason);
    }
    resolver = resolve;
    rejector = reject;
    signal?.addEventListener("abort", () => {
      reject(signal.reason);
    });
  });
  return { promise, rejector, resolver };
}
export {
  createPromise
};
//# sourceMappingURL=createPromise.js.map
